<!-- <h4 class="title">Guarantor / Reference Datails</h4> -->

<div class="col-md-8">
  <div class="card-box">
    <h4 class="title-f">Guarantor Datails</h4>
    <div class="row" style="padding: 0px 0px 23px 10px;">
      <div class="col-md-3">
        <h5 class="form-lable">Guarantor A/C no.:</h5>
        <input type="text" pInputText placeholder="">
      </div>
      <div class="col-md-3">
        <h5 class="form-lable">Name:</h5>
        <input type="text" pInputText placeholder="">
      </div>
      <div class="col-md-3">
        <h5 class="form-lable">Profession:</h5>
        <input type="text" pInputText placeholder="">
      </div>
      <div class="col-md-3">
        <h5 class="form-lable">Current Organization / Business:</h5>
        <input type="text" pInputText placeholder="">
      </div>
      
      <!-- <div class="col-md-12 mt-20">
            <button type="button" class="btn btn-primary">Add</button>
       </div> -->
  
    </div>
  </div>
</div>
<div class="col-md-4">
  <div class="card-box">
    <h4 class="title-f">Reference Details</h4>
    <div class="row" style="padding: 0px 0px 23px 10px;">
      <div class="col-md-4">
        <h5 class="form-lable">Name:</h5>
        <input type="text" pInputText placeholder="">
      </div>
      <div class="col-md-4">
        <h5 class="form-lable">Relationship:</h5>
        <input type="text" pInputText placeholder="">
      </div>
      <div class="col-md-4">
        <h5 class="form-lable">Mobile No:</h5>
        <input type="text" pInputText placeholder="">
      </div>
      
      <!-- <div class="col-md-12 mt-20">
            <button type="button" class="btn btn-primary">Add</button>
       </div> -->
  
    </div>
  </div>
</div>


<!-- <h4 class="title">Guarantor Datails</h4>
<div class="doc-table">
  <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
      [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
      <ng-template pTemplate="header">
  <tr style="text-align: center;">
    <th>Guarantor A/C no.</th>
    <th>Name</th>
    <th>Profession</th>
    <th>Current Organization / Business</th>

  </tr>
  <tr style="text-align: center;">
    <td><input type=""></td>
    <td><input type=""></td>
    <td><input type=""></td>
    <td><input type=""></td>
  </tr>
      </ng-template>
   </p-table>  </div>
  </div>
  <br>




<h4 class="title">Reference Details</h4>
<div class="doc-table">
  <div class="card-box"> <p-table [value]="rows | filter:searchQR" styleClass="ui-table-customers" #tt [paginator]="false" [rows]="5"
      [rowHover]="true" [rowsPerPageOptions]="[5,10,25,50]" [showCurrentPageReport]="true"
      currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries" [globalFilterFields]="['type']">
      <ng-template pTemplate="header">
  <tr style="text-align: center;">
    <th>Name</th>
    <th></th>
    <th>Mobile No.</th>

  </tr>
  <tr style="text-align: center;">
    <td><input type=""></td>
    <td><input type=""></td>
    <td><input type=""></td>
  </tr>
      </ng-template>
   </p-table>  </div>
  </div>
  <br> -->

